const REGISTER_URL = "https://forms.gle/qoQDMbd6KjhicfiC9";

export default REGISTER_URL;
